module.exports = __webpack_public_path__ + "static/media/ehealth-bg1-preview.1ea8d8a0.jpg";